
import * as ReactRedux from 'react-redux'; 
import { iActionType, Translation, INIT_TRANSLATIONS, iNavData, graphData } from '../../models/models';
export const STATE_KEY = 'app';


export interface AppProps extends ReactRedux.DispatchProp<any>{
	appState:AppState;
	loadData:(e)=>iActionType;
}
export enum WINDOW_VIEWS {
	SPLASH, 
	CONTENT
}

export interface AppState{
	locale:Translation;
	navData:iNavData[]; 
	data: graphData[];
	selectedGraph: any;
	selectedFilter: any;
	selectedSecondFilter: any;

}
export const AppInitState:AppState = {
	locale:INIT_TRANSLATIONS,
	navData:[],
	data:[],
	selectedGraph: [],
	selectedFilter: null,
	selectedSecondFilter: null,
}

export interface inAppState{
}

export const inAppInitialState:inAppState = {
}
